<template>
  <v-container grid-list-xs>
    <v-row class="justify-center">
      <v-col sm="8" xs="12">
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              All Cash Accounts
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon>mdi-cash-marker</v-icon>
          </v-toolbar>
          <v-card-text>
            <v-list>
              <v-list-item>
                <cashDisplay
                  colorName="purple"
                  :isloading="isLoading"
                  :Balance="AvailbeBlc"
                ></cashDisplay>
              </v-list-item>
              <v-list-item
                v-for="item in cashAccounts"
                :key="item._id + item.AccountName"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.AccountName }}</v-list-item-title>
                </v-list-item-content>

                <v-btn
                  icon
                  :id="item._id"
                  color="success"
                  :loading="clicked === item._id ? true : false"
                  @click="showBalance(item)"
                >
                  <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Balance Dialog -->
    <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition">
      <v-card v-if="Balance.length > 0">
        <v-card-title class="headline white--text green justify-center">{{
          Balance.Name
        }}</v-card-title>

        <v-card-text class="font-weight-black title text-center">
          <template v-for="(item, index) in Balance">
            <p
              v-if="item.Amount != 0"
              :key="index"
              :class="{ 'red--text': item.loan == 'yess' ? true : false }"
            >
              {{ item.AmountType }}: {{ item.Amount.toLocaleString() }}
              {{ item.AmountType | MoneySigns }}
            </p>
          </template>
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-card-title class="headline white--text blue justify-center">{{
          Balance.Name
        }}</v-card-title>

        <v-card-text class="font-weight-black title text-center">
          Empty Balance
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import cashDisplay from "@/components/displayCash.vue";
import axios from "axios";
export default {
  components: { cashDisplay },
  data() {
    return {
      cashAccounts: [],
      clicked: "",
      Balance: [],
      dialog: false,
      AvailbeBlc: [],
      isLoading: false,
    };
  },
  methods: {
    AvailibleBalance() {
      return this.$store.dispatch("INSERT_ONLY", {
        url: `/Reports/Alltotalcash`,
        data: {},
      });
    },
    AccountBalance(AccName) {
      //   console.log(AccName);
      return this.$store.dispatch("INSERT_ONLY", {
        url: "/qarash/totalcash",
        data: { Account: AccName, cashType: null },
      });
    },
    AccountsReq(name) {
      return this.$store.dispatch("FIND_BY_VALUE_ONLY", {
        url: "/qarash/Accounts",
        ID: name,
      });
    },
    LoadAccounts() {
      this.isLoading = true;
      axios
        .all([this.AccountsReq("Cash"), this.AvailibleBalance()])
        .then(result => {
          // console.log(result);
          this.cashAccounts = result[0].data;
          this.AvailbeBlc = result[1].data;
          this.isLoading = false;
        })
        .catch(() => {
          // console.log(error);
        });
    },
    showBalance({ AccountName, _id }) {
      (this.clicked = _id),
        this.AccountBalance(AccountName)
          .then(result => {
            // console.log(result);
            this.clicked = "";
            this.Balance = result.data;
            this.Balance.Name = AccountName;
            this.dialog = true;
          })
          .catch(() => {
            // console.log(error);
            this.clicked = "";
          });
    },
  },
  mounted() {
    this.LoadAccounts();
  },
};
</script>
